module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#user",
      toString: function () {
        return this.url;
      }
    }